export const SET_USER_SESSION='SET_USER_SESSION';